import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { fadeInOutVoid } from '../ce-animation/ce-animation.lib';

@Component({
    selector: 'ce-tooltip',
    imports: [CommonModule],
    templateUrl: './ce-tooltip.component.html',
    styleUrl: './ce-tooltip.component.scss',
    animations: fadeInOutVoid
})
export class CeTooltipComponent {
    @Input() text!: string;
    @Input() hide = false;
    @Input() classList!: string | null;
}
